import { moodColor } from "@/lib/api";
import { Sparkle } from "@phosphor-icons/react";
import MoodChart from "@/components/MoodChart";

export default function WeeklyInsights({ data, loading }) {
  return (
    <div className="card p-8" data-testid="weekly-insights">
      <div className="flex items-center justify-between mb-2">
        <p className="eyebrow">This week's reflection</p>
        {data?.dominant_mood && (
          <span
            className="text-xs px-3 py-1 rounded-full"
            style={{
              backgroundColor: `${moodColor(data.dominant_mood)}22`,
              color: "#2A3326",
            }}
          >
            mostly {data.dominant_mood}
          </span>
        )}
      </div>
      <h3 className="font-serif text-2xl sm:text-3xl mt-2 mb-6 leading-tight">
        Your emotional <span className="italic text-brand">arc</span>
      </h3>

      <MoodChart trend={data?.trend || []} dominantMood={data?.dominant_mood || "neutral"} />

      <div className="mt-8 pt-6 border-t border-bone-300">
        <div className="flex items-center gap-2 mb-3">
          <Sparkle size={16} weight="fill" className="text-brand" />
          <p className="eyebrow !text-ink-900">AI insight</p>
        </div>
        {loading ? (
          <div className="space-y-2">
            <div className="h-3 bg-bone-200 rounded animate-pulse" />
            <div className="h-3 bg-bone-200 rounded animate-pulse w-5/6" />
            <div className="h-3 bg-bone-200 rounded animate-pulse w-4/6" />
          </div>
        ) : (
          <p
            className="font-serif text-lg text-ink-700 leading-relaxed italic"
            data-testid="weekly-insight-text"
          >
            "{data?.insight}"
          </p>
        )}
        <p className="text-xs text-ink-500 mt-4">
          Based on {data?.entries_count || 0} entries from the last 7 days
        </p>
      </div>
    </div>
  );
}
